import { useAppDispatch, useAppSelector } from '@store/hooks'
import { createMenu, deleteMenu, updateMenu } from '@store/MenuReducer'
import { SBRM, SBRMForm, useSBRMForm } from '@supplement-bacon/sbrm-react'
import MetadataKey from '@utils/MetadataKey'
import { forwardRef } from 'react'
import { langList } from '../../../factories/Utils'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const MenuForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { getMetadata } = useSBRMForm()
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.menu)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          const data = new FormData()
          const localizedFields = langList.map((lang) => lang.code)
          localizedFields.map((field) => {
            const value = values[field]
            data.append(field + '[label]', value.label)
            if (value.file) {
              data.append(field + '[file]', value.file[0].originFileObj)
            }
          })

          const venueSlug: string = getMetadata(MetadataKey.VenueSlug) ?? ''
          return dispatch(createMenu(venueSlug, data)).then(() => {
            return true
          })
        },
        update: async (values) => {
          const data = new FormData()
          data.append('id', values.id)
          const localizedFields = langList.map((lang) => lang.code)
          localizedFields.map((field) => {
            const value = values[field]
            data.append(field + '[label]', value.label)
            if (value.file && value.file[0]) {
              data.append(field + '[file]', value.file[0].originFileObj)
            }
          })
          const venueSlug: string = getMetadata(MetadataKey.VenueSlug) ?? ''
          return dispatch(updateMenu(venueSlug, data)).then(() => {
            return true
          })
        },
        delete: async (values) => {
          const venueSlug: string = getMetadata(MetadataKey.VenueSlug) ?? ''
          return dispatch(deleteMenu(venueSlug, values)).then(() => {
            return true
          })
        },
      }}
    />
  )
})

MenuForm.displayName = 'MenuForm'

export default MenuForm
